function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* jshint esversion: 8 */
import _debounce from 'lodash-es/debounce';
import { CommonBuilder } from './Helpers/CommonBuilder';
import { DropdownBuilder } from './Helpers/DropdownBuilder';
import { FormManager } from './Helpers/FormManager';
import { ICSCalendarBuilder } from './Helpers/ICSCalendarBuilder';
import { MapBuilder } from './Helpers/MapBuilder';
import { OAuthService } from './Services/OAuthService';
import { OnlineDirectoryApiService } from './Services/OnlineDirectoryApiService';
import { UserService } from './Services/UserService';
import { AttributeFilter } from './Shared/AttributeFilter';
import { ComponentBase } from './Shared/ComponentBase';
import { I18N } from './Shared/I18n';
import { QueryStringFilter } from './Shared/QueryStringFilter';
import { ReturnContext } from './Shared/ReturnContextProvider';
export var MppOnlineDirectory = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppOnlineDirectory, _ComponentBase);

  var _super = _createSuper(MppOnlineDirectory);

  function MppOnlineDirectory() {
    _classCallCheck(this, MppOnlineDirectory);

    return _super.call(this);
  }

  _createClass(MppOnlineDirectory, [{
    key: "attributeChangedCallback",
    value: function () {
      var _attributeChangedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name, oldValue, newValue) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("Attribute changed!", "".concat(name, " changed from ").concat(oldValue, " to ").concat(newValue));

                if (!this._$searchForm) {
                  _context.next = 5;
                  break;
                }

                this.loadAttributes();
                _context.next = 5;
                return this.SearchOnlineDirectory();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function attributeChangedCallback(_x, _x2, _x3) {
        return _attributeChangedCallback.apply(this, arguments);
      }

      return attributeChangedCallback;
    }()
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.hideAddress = this.hasAttribute("hideaddress") && this.getAttribute("hideaddress").toLowerCase() === "true";
      this.hideEmail = this.hasAttribute("hideemail") && this.getAttribute("hideemail").toLowerCase() === "true";
      this.hideBirthdayIcon = this.hasAttribute("hidebirthdayicon") && this.getAttribute("hidebirthdayicon").toLowerCase() === "true";
      this.hideFamilyLink = this.hasAttribute("hidefamilylink") && this.getAttribute("hidefamilylink").toLowerCase() === "true";

      if (!!this._$searchForm) {
        AttributeFilter.ApplyFilter(this, this._$searchForm);
      }

      return true;
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var i18n;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new I18N(MppOnlineDirectory.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                i18n = _context2.sent;
                this._i18n = i18n;
                this._minimumKeywordSearchLength;
                this._directorySearchHouseholdPrefix;
                this._directorySearchInputTimeout;
                this._currentUser;
                this._isMobileDevice = CommonBuilder.isMobile();
                this._onlineDirectoryApiService = new OnlineDirectoryApiService();
                this.BindInitialHtmlElements();
                this.loadAttributes();
                _context2.next = 14;
                return this.LoadPage();

              case 14:
                this._$loginButton.addEventListener("click", function () {
                  OAuthService.SignIn();
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "LoadPage",
    value: function () {
      var _LoadPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var userCanAccess;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.UserCanAccessPage();

              case 2:
                userCanAccess = _context3.sent;

                if (!userCanAccess) {
                  _context3.next = 13;
                  break;
                }

                this.BindHtmlElements();
                _context3.next = 7;
                return this.LoadConfigData();

              case 7:
                this.BindEventListeners();
                this.HideLoadingIndicator();
                this.DisplayEnterSearchMessage();
                this.ShowFormWrapper();
                _context3.next = 13;
                return this.SearchOnlineDirectory();

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function LoadPage() {
        return _LoadPage.apply(this, arguments);
      }

      return LoadPage;
    }()
  }, {
    key: "UserCanAccessPage",
    value: function () {
      var _UserCanAccessPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var userCanAccess;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return UserService.GetCurrentUser();

              case 3:
                this._currentUser = _context4.sent;
                _context4.next = 6;
                return this.UserCanAccessDirectory();

              case 6:
                userCanAccess = _context4.sent;
                this._$loginButtonContainer.style.display = "none";

                if (!userCanAccess) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt("return", true);

              case 12:
                this.HideLoadingIndicator();
                this.DisplayNotAuthorizedToViewMessage();
                return _context4.abrupt("return", false);

              case 15:
                _context4.next = 23;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](0);
                console.error('error', _context4.t0);
                this._$loginButtonContainer.style.display = "";
                this.HideLoadingIndicator();
                return _context4.abrupt("return", false);

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 17]]);
      }));

      function UserCanAccessPage() {
        return _UserCanAccessPage.apply(this, arguments);
      }

      return UserCanAccessPage;
    }()
  }, {
    key: "UserCanAccessDirectory",
    value: function () {
      var _UserCanAccessDirectory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var userCanAccess;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._onlineDirectoryApiService.UserCanAccessDirectory();

              case 2:
                userCanAccess = _context5.sent;
                return _context5.abrupt("return", userCanAccess);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function UserCanAccessDirectory() {
        return _UserCanAccessDirectory.apply(this, arguments);
      }

      return UserCanAccessDirectory;
    }()
  }, {
    key: "BindInitialHtmlElements",
    value: function BindInitialHtmlElements() {
      this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container mpp-online-directory"><div id="directoryFormWrapper" class="mppw-form-wrapper" style="display: none;"><h1>${ this._i18n.onlineDirectoryLabel }</h1><form class="mppw-form mppw-form-validate" id="searchForm"><input type="hidden" id="householdId" name="householdId" class="search-option"/><div class="mppw-form-field mppw-form-field__static-container"><select name="congregationId" class="mppw-form-field__control search-option" id="congregationId" value=""></select> <label class="mppw-form-field__label" for="congregationId">${ this._i18n.congregationDropdownLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><input name="keyword" class="mppw-form-field__control search-option" autocomplete="off" type="search" id="keywordSearchText"/> <label class="mppw-form-field__label" for="keywordSearchText">${ this._i18n.keyWordLabel }</label><div id="householdFilterChipId" class="mpp-online-directory-chip hidden"><span id="householdFilterName" class="mpp-online-directory-chip-name"></span> <span id="clearFilterByHouseholdId" class="mpp-online-directory-closebtn">&times;</span></div></div></form></div><div id="loginButtonContainer" class="mppw-centered" style="display: none;"><div class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.pleaseLoginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="Login"/></div><div id="enterSearchMessageContainer"></div><div id="loadingContainer"><i class="mppw-spinner"></i></div><div id="emptyContainer"></div><div id="onlineDirectoryCardList" class="mppw-card--grid"></div><div id="viewMoreContainer"></div></div>` ;
      this._$loadingContainer = this._root.querySelector("#loadingContainer");
      this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
      this._$loginButton = this._root.querySelector("#loginButton");
      this._$emptyContainer = this._root.querySelector("#emptyContainer");
    }
  }, {
    key: "BindHtmlElements",
    value: function BindHtmlElements() {
      this._$searchForm = this._root.querySelector("#searchForm");
      this._$congregationId = this._root.querySelector("#congregationId");
      this._$householdId = this._root.querySelector("#householdId");
      this._$viewMoreContainer = this._root.querySelector("#viewMoreContainer");
      this._$enterSearchMessageContainer = this._root.querySelector("#enterSearchMessageContainer");
      this._$onlineDirectoryCardList = this._root.querySelector("#onlineDirectoryCardList");
      this._$keywordSearchText = this._root.querySelector("#keywordSearchText");
      this._$directoryFormWrapper = this._root.querySelector("#directoryFormWrapper");
      this._$householdFilterChipId = this._root.querySelector("#householdFilterChipId");
      this._$householdFilterName = this._root.querySelector("#householdFilterName");
      this._$clearFilterByHouseholdId = this._root.querySelector("#clearFilterByHouseholdId");
    }
  }, {
    key: "LoadConfigData",
    value: function () {
      var _LoadConfigData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var configData, returnContext;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this._onlineDirectoryApiService.GetOnlineDirectoryConfigData();

              case 3:
                configData = _context6.sent;

                if (!!configData) {
                  DropdownBuilder.LoadDropdown(this._$congregationId, configData.congregations, this._i18n.congregationPlaceholderText);
                  this._minimumKeywordSearchLength = configData.minimumDirectorySearchLength;
                  this._directorySearchHouseholdPrefix = configData.directorySearchHouseholdPrefix;
                  this._directorySearchInputTimeout = configData.directorySearchInputTimeout;
                  returnContext = ReturnContext.Get(ReturnContext.Categories.OnlineDirectory);

                  if (!!returnContext && returnContext.Url == window.location.href) {
                    ReturnContext.ApplyFilter(returnContext.FormData, this._$searchForm, null);
                  } else {
                    QueryStringFilter.ApplyFilter(this._$searchForm, null);
                  }

                  AttributeFilter.ApplyFilter(this, this._$searchForm, true);
                }

                _context6.next = 12;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                this.HideFormWrapper();
                this.HideLoadingIndicator();
                this.DisplayNotAuthorizedToViewMessage();

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function LoadConfigData() {
        return _LoadConfigData.apply(this, arguments);
      }

      return LoadConfigData;
    }()
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners() {
      var _this2 = this;

      this._$congregationId.addEventListener("change", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(event) {
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  event.preventDefault();
                  _context7.next = 3;
                  return _this2.SearchOnlineDirectory();

                case 3:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }());

      this._$searchForm.addEventListener("submit", /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(event) {
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  event.preventDefault();
                  _context8.next = 3;
                  return _this2.SearchOnlineDirectory();

                case 3:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x5) {
          return _ref2.apply(this, arguments);
        };
      }());

      var delayedSearch = _debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this2.SearchOnlineDirectory();

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      })), this._directorySearchInputTimeout);

      this._$keywordSearchText.addEventListener("keyup", delayedSearch);

      this._$clearFilterByHouseholdId.addEventListener("click", /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(event) {
          return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  event.preventDefault();

                  _this2.SetHouseholdId(null);

                  _this2._$householdFilterChipId.classList.add("hidden");

                  _context10.next = 5;
                  return _this2.SearchOnlineDirectory();

                case 5:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));

        return function (_x6) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "BindCardButtonEventListeners",
    value: function BindCardButtonEventListeners() {
      var _this3 = this;

      var self = this;

      var filterByHouseholdIds = this._root.querySelectorAll(".filterByHouseholdId");

      var _iterator = _createForOfIteratorHelper(filterByHouseholdIds),
          _step;

      try {
        var _loop = function _loop() {
          var filterByHousehold = _step.value;
          filterByHousehold.addEventListener("click", /*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(event) {
              return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                  switch (_context11.prev = _context11.next) {
                    case 0:
                      event.preventDefault();

                      _this3.SetHouseholdId(filterByHousehold.dataset.householdid);

                      _context11.next = 4;
                      return _this3.SearchOnlineDirectory();

                    case 4:
                    case "end":
                      return _context11.stop();
                  }
                }
              }, _callee11);
            }));

            return function (_x7) {
              return _ref5.apply(this, arguments);
            };
          }());
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var modalImages = this._root.querySelectorAll(".modal-big-image");

      var _iterator2 = _createForOfIteratorHelper(modalImages),
          _step2;

      try {
        var _loop2 = function _loop2() {
          var modalImage = _step2.value;
          modalImage.addEventListener("click", function (event) {
            event.preventDefault();
            var modalId = "#".concat(modalImage.dataset.bigimagemodal);

            var modal = self._root.querySelector(modalId);

            modal.classList.add("open");

            _this3.HideBigImages();

            var exitButtons = modal.querySelectorAll(".modal-exit");
            exitButtons.forEach(function (exitButton) {
              exitButton.addEventListener("click", function (event) {
                event.preventDefault();
                modal.classList.remove("open");
              });
            });
          });
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var modalLinks = this._root.querySelectorAll(".modal-link");

      var _iterator3 = _createForOfIteratorHelper(modalLinks),
          _step3;

      try {
        var _loop3 = function _loop3() {
          var modalLink = _step3.value;
          modalLink.addEventListener("click", function (event) {
            event.preventDefault();
            var modalId = "#".concat(modalLink.dataset.emailmodal);

            var modal = self._root.querySelector(modalId);

            modal.classList.add("open");

            _this3.HideEmailSentMessages();

            var exitButtons = modal.querySelectorAll(".modal-exit");
            exitButtons.forEach(function (exitButton) {
              exitButton.addEventListener("click", function (event) {
                event.preventDefault();
                modal.classList.remove("open");
              });
            });
          });
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop3();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var emailSubmitButtons = this._root.querySelectorAll(".email-submit-btn");

      var _iterator4 = _createForOfIteratorHelper(emailSubmitButtons),
          _step4;

      try {
        var _loop4 = function _loop4() {
          var emailSubmitButton = _step4.value;
          emailSubmitButton.addEventListener("click", /*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(event) {
              var emailSubmitId, emailForm, emailFormManager;
              return regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                  switch (_context12.prev = _context12.next) {
                    case 0:
                      event.preventDefault();
                      emailSubmitId = "".concat(emailSubmitButton.dataset.emailsubmitid);
                      emailForm = self._root.querySelector("#sendEmailForm-".concat(emailSubmitId));
                      emailFormManager = new FormManager(emailForm);
                      _context12.next = 6;
                      return _this3.SubmitEmailForm(emailFormManager, emailForm);

                    case 6:
                      _this3.DisplayEmailSentMessage("#emailMessageContainer-".concat(emailSubmitId));

                    case 7:
                    case "end":
                      return _context12.stop();
                  }
                }
              }, _callee12);
            }));

            return function (_x8) {
              return _ref6.apply(this, arguments);
            };
          }());
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop4();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "SubmitEmailForm",
    value: function () {
      var _SubmitEmailForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(emailFormManager, emailForm) {
        var formData;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(!!emailForm && !!emailForm)) {
                  _context13.next = 6;
                  break;
                }

                if (!emailFormManager.IsValid()) {
                  _context13.next = 6;
                  break;
                }

                formData = new FormData(emailForm);
                _context13.next = 5;
                return this._onlineDirectoryApiService.CreateEmail(formData);

              case 5:
                emailFormManager.Reset();

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function SubmitEmailForm(_x9, _x10) {
        return _SubmitEmailForm.apply(this, arguments);
      }

      return SubmitEmailForm;
    }()
  }, {
    key: "SetHouseholdId",
    value: function SetHouseholdId(householdIdValue) {
      //this._$householdId.value = householdIdValue;
      this._$keywordSearchText.value = "".concat(this._directorySearchHouseholdPrefix).concat(householdIdValue);
    }
  }, {
    key: "GetHouseholdId",
    value: function GetHouseholdId() {
      return this._$householdId.value;
    }
  }, {
    key: "SetHouseholdName",
    value: function SetHouseholdName(householdName) {
      // Only display the family chip if there is a household id value set
      if (!!this.GetHouseholdId()) {
        var householdIdElement = this._root.querySelector("[data-householdid='".concat(this._$householdId.value, "']"));

        this._$householdFilterChipId.classList.remove("hidden");

        this._$householdFilterName.innerHTML = "".concat(householdIdElement.dataset.householdname, " ").concat(this._i18n.familyLabel);
        ;
      }
    }
  }, {
    key: "DoesKeywordMeetMinimumLength",
    value: function DoesKeywordMeetMinimumLength() {
      if (this.GetKeywordTextLength() < this._minimumKeywordSearchLength) {
        return false;
      }

      return true;
    }
  }, {
    key: "SetSearchFilters",
    value: function SetSearchFilters() {
      var householdId = this._$householdId.value;

      if (!!householdId && this.GetKeywordTextLength() <= 0) {
        // Set keyword input to household id
        this.SetHouseholdId(householdId);
      }
    }
  }, {
    key: "DoesFormMeetSearchRequirements",
    value: function DoesFormMeetSearchRequirements() {
      return this.DoesKeywordMeetMinimumLength();
    }
  }, {
    key: "GetKeywordTextLength",
    value: function GetKeywordTextLength() {
      return this._$keywordSearchText.value.trim().length;
    }
  }, {
    key: "SearchOnlineDirectory",
    value: function () {
      var _SearchOnlineDirectory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var _this4 = this;

        var formData;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                formData = new FormData(this._$searchForm);
                this.SetSearchFilters();

                if (!this.DoesFormMeetSearchRequirements()) {
                  _context14.next = 17;
                  break;
                }

                this.HideAllMessages();
                this.ShowLoadingIndicator();
                ReturnContext.Set(ReturnContext.Categories.OnlineDirectory, formData);
                _context14.prev = 6;
                _context14.next = 9;
                return this._onlineDirectoryApiService.SearchOnlineDirectory(formData).then(function (data) {
                  _this4.HideLoadingIndicator();

                  _this4.BuildOnlineDirectoryCards(data);

                  _this4.BindCardButtonEventListeners();

                  _this4.SetHouseholdName();
                })["catch"](function (e) {
                  _this4.HideFormWrapper();

                  _this4.HideLoadingIndicator();

                  _this4.DisplayNotAuthorizedToViewMessage();
                });

              case 9:
                _context14.next = 15;
                break;

              case 11:
                _context14.prev = 11;
                _context14.t0 = _context14["catch"](6);
                this.HideLoadingIndicator();
                this.DisplayNotAuthorizedToViewMessage();

              case 15:
                _context14.next = 18;
                break;

              case 17:
                if (this.GetKeywordTextLength() < this._minimumKeywordSearchLength) {
                  this.HideDirectoryCardHtml();
                  this.HideAllMessages();
                  this.DisplayEnterSearchMessage();
                  ReturnContext.Set(ReturnContext.Categories.OnlineDirectory, formData);
                }

              case 18:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[6, 11]]);
      }));

      function SearchOnlineDirectory() {
        return _SearchOnlineDirectory.apply(this, arguments);
      }

      return SearchOnlineDirectory;
    }()
  }, {
    key: "BuildOnlineDirectoryCards",
    value: function BuildOnlineDirectoryCards(directoryData) {
      this._$viewMoreContainer.innerHTML = "";
      var onlineDirectoryCardListHTML = "";

      if (!!directoryData && directoryData.length) {
        var _iterator5 = _createForOfIteratorHelper(directoryData),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var directoryItem = _step5.value;
            var contactImageUrl = directoryItem.contactImageUrl,
                displayName = directoryItem.displayName,
                householdId = directoryItem.householdId,
                householdName = directoryItem.householdName,
                householdPosition = directoryItem.householdPosition,
                homePhone = directoryItem.homePhone,
                homePhoneUnlisted = directoryItem.homePhoneUnlisted,
                contactId = directoryItem.contactId,
                mobilePhoneUnlisted = directoryItem.mobilePhoneUnlisted,
                mobilePhone = directoryItem.mobilePhone,
                dateofBirth = directoryItem.dateofBirth,
                dateofBirthShortDate = directoryItem.dateofBirthShortDate,
                addressId = directoryItem.addressId,
                homeAddressUnlisted = directoryItem.homeAddressUnlisted,
                addressLine1 = directoryItem.addressLine1,
                city = directoryItem.city,
                state = directoryItem.state,
                postalCode = directoryItem.postalCode,
                emailUnlisted = directoryItem.emailUnlisted,
                emailAddress = directoryItem.emailAddress;
            var IMAGE_URL_SRC = !!contactImageUrl ? contactImageUrl : "".concat(this._appRoot, "/Content/icons/icon-household-member.svg");
            var CAN_SHOW_MOBILE_PHONE = this.CanShowMobilePhone(directoryItem);
            var CAN_SHOW_HOME_PHONE = this.CanShowHomePhone(directoryItem);
            var CAN_SHOW_ADDRESS = this.CanShowAddress(directoryItem);
            var CAN_SHOW_EMAIL = this.CanShowEmail(directoryItem);
            var CAN_SHOW_FAMILY_LINK = this.CanShowFamily(directoryItem);
            var MOBILE_PHONE_HTML = this.GetPhoneHtml(mobilePhone);
            var HOME_PHONE_HTML = this.GetPhoneHtml(homePhone);
            var GOOGLE_MAPS_LINK = MapBuilder.GetGoogleMapsLink(directoryItem);
            var ICS_CALENDAR_LINK = this.GetICSCalendarLink(directoryItem);
            var FULL_ADDRESS_STRING = this.GetAddressAsString(directoryItem);
            onlineDirectoryCardListHTML =  `<div class="mpp-card mpp-online-directory mpp-card--online-directory" id="${contactId}"><div class="mpp-card--online-directory-body"><div class="mpp-online-directory-row"><div class="mpp-online-directory-col-sm mr-10"><a class="mpp-online-directory--header-wrapper ${!!contactImageUrl ? 'modal-big-image' : 'image-placeholder'}" data-bigimagemodal="modal-big-image-${contactId}" href="#" id="showBigImageModal" data-searchmode="0" title="${!!contactImageUrl ? 'Click to see bigger image' : ''}"><img class="${!!contactImageUrl ? 'mpp-card--online-directory-image' : 'mpp-card--online-directory-placeholder'}" src="${IMAGE_URL_SRC}"/></a></div><div class="mpp-online-directory-col-lg"><div class="mpp-online-directory-row"><h3 class="mpp-card--online-directory-title padding-left">${displayName}</h3></div><div class="mpp-online-directory-row min-height"><p class="padding-left">${householdPosition}</p></div><div class="mpp-online-directory-row row-wrap-text mpp-online-directory-phones min-height"><div class="mpp-online-directory-col-md ${CAN_SHOW_MOBILE_PHONE ? '' : 'hidden'}">m: ${MOBILE_PHONE_HTML}</div><div class="mpp-online-directory-col-md mpp-online-directory-phone ${CAN_SHOW_HOME_PHONE ? '' : 'hidden'}" data-phonenumber="${homePhone}">h: ${HOME_PHONE_HTML}</div></div><div class="mpp-online-directory-row row-pt"><div class="mpp-card--online-directory-footer"><div class="mpp-online-directory-col-sm ${!!ICS_CALENDAR_LINK ? '' : 'hidden'}"><a class="mpp-online-directory--header-wrapper" href="${ICS_CALENDAR_LINK}" id="downloadICSCalendar" data-searchmode="0"><img class="mpp-icon--online-directory" src="${this._appRoot}/Content/icons/icon-birthday-cake.svg"><br/><span>${dateofBirthShortDate}</span></a></div><div class="mpp-online-directory-col-sm ${CAN_SHOW_EMAIL ? '' : 'hidden'}"><a class="mpp-online-directory--header-wrapper modal-link" data-emailmodal="modal-email-${contactId}" href="#" id="showEmailModal" data-searchmode="0"><img class="mpp-icon--online-directory" src="${this._appRoot}/Content/icons/icon-envelope.svg"><br/><span>${this._i18n.emailLabel}</span></a></div><div class="mpp-online-directory-col-sm ${CAN_SHOW_ADDRESS ? '' : 'hidden'}"><a class="mpp-online-directory--header-wrapper" target="_blank" title="${FULL_ADDRESS_STRING}" href="${GOOGLE_MAPS_LINK}" id="viewGoogleMaps" data-searchmode="0"><img class="mpp-icon--online-directory" src="${this._appRoot}/Content/icons/icon-map-location.svg"><br/><span>${this._i18n.mapLabel}</span></a></div><div class="mpp-online-directory-col-sm ${CAN_SHOW_FAMILY_LINK ? '' : 'hidden'}"><a class="mpp-online-directory--header-wrapper filterByHouseholdId" href="#" id="filterByHouseholdId" data-householdid="${householdId}" data-householdname="${householdName}"><img class="mpp-icon--online-directory" src="${this._appRoot}/Content/icons/icon-household-user.svg"><br/><span>${this._i18n.familyLabel}</span></a></div></div></div></div></div></div><div id="emailModalDiv-${contactId}"></div><div id="bigImageModalDiv-${contactId}"></div></div>` ;
            this._$onlineDirectoryCardList.innerHTML += onlineDirectoryCardListHTML;

            var emailModalDiv = this._$onlineDirectoryCardList.querySelector("#emailModalDiv-".concat(contactId));

            emailModalDiv.innerHTML =  `<div class="mpp-online-directory-modal" id="modal-email-${contactId}"><div class="mpp-online-directory-modal-bg modal-exit"></div><div class="mpp-online-directory-modal-container mpp-online-directory-modal-container-md"><button class="mpp-online-directory-modal-close modal-exit">X</button><h2>${this._i18n.sendEmailLabel}</h2><form id="sendEmailForm-${contactId}" class="mppw-form mppw-form-validate"><input type="hidden" name="EmailToContactId" value="${contactId}"/> <input type="hidden" name="EmailFromContactId" value="${this._currentUser.contactId}"/> <input type="hidden" name="EmailFromUserId" value="${this._currentUser.user.userId}"/><div class="form--row" id="sendToContainer"><div class="form--col"><div><label><b>${this._i18n.emailToLabel}:</b> ${displayName} (${emailAddress})</label></div></div></div><div class="form--row" id="sendFromContainer"><div class="form--col"><div><label><b>${this._i18n.emailFromLabel}:</b> ${this._currentUser.user.firstName} (${this._currentUser.user.email})</label></div></div></div><div class="form--row" id="subjectContainer"><div class="form--col"><div class="mppw-form-field"><input name="EmailSubject" id="emailSubject" type="text" class="mppw-form-field__control" data-required-message="subject required" required/> <label class="mppw-form-field__label" for="inquire_emailText">${this._i18n.emailSubjectLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><textarea name="EmailBody" id="emailBody" class="mppw-form-field__control" rows="6" maxlength="2000" minlength="0" data-required-message="body required" required value=" "></textarea> <label class="mppw-form-field__label" for="inquire_feedbackDetails">${this._i18n.emailBodyLabel}*:</label></div></div></div><div class="mppw-centered"><input id="emailSubmitButton" type="submit" class="mppw-btn primary email-submit-btn" data-emailsubmitid="${contactId}" value="${this._i18n.emailSendLabel}"/> <input id="emailCancelButton" type="submit" class="mppw-btn primary modal-exit" value="${this._i18n.emailCancelLabel}"/></div></form><div id="emailMessageContainer-${contactId}" class="emailMessageContainer"></div></div></div>` ;

            var bigImageModalDiv = this._$onlineDirectoryCardList.querySelector("#bigImageModalDiv-".concat(contactId));

            bigImageModalDiv.innerHTML =  `<div class="mpp-online-directory-modal" id="modal-big-image-${contactId}"><div class="mpp-online-directory-modal-bg modal-exit"></div><div class="mpp-online-directory-modal-container mpp-online-directory-modal-container-md"><button class="mpp-online-directory-modal-close modal-exit">X</button><h2>${displayName}</h2><form class="mppw-form"><div class="form--row"><div class="form--col"><img class="mpp-card--online-directory-big-image" src="${IMAGE_URL_SRC}"/></div></div><div class="mppw-centered"><input id="bigImageCancelButton" type="submit" class="mppw-btn primary modal-exit" value="Close"/></div></form><div id="bigImageContainer-${contactId}" class="bigImageContainer"></div></div></div>` ;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        if (directoryData.length > 20) {
          this.DisplayViewMoreMessage();
        }
      } else {
        this.DisplayNoResultsFoundMessage();
      }
    }
  }, {
    key: "GetAddressAsString",
    value: function GetAddressAsString(data) {
      if (!!data && !!data.addressLine1) {
        return "".concat(data.addressLine1, ",").concat(data.city, ",").concat(data.state, ",").concat(data.postalCode);
      }
    }
  }, {
    key: "GetICSCalendarLink",
    value: function GetICSCalendarLink(data) {
      if (!!data && !!data.dateofBirth && this.hideBirthdayIcon === false) {
        var eventTitle = "Happy Birthday ".concat(data.displayName, "!");
        var eventStartDate = new Date().getFullYear() + data.dateofBirth.slice(4); // Replace year with current year

        return ICSCalendarBuilder.GetICSHrefValue(eventTitle, "", "", eventStartDate, "", true);
      }

      return false;
    }
  }, {
    key: "GetPhoneHtml",
    value: function GetPhoneHtml(phoneNumber) {
      var phoneHtml = "";

      if (!!phoneNumber) {
        if (this._isMobileDevice) {
          phoneHtml = "<a href=\"tel:".concat(phoneNumber, "\" class=\"mpp-online-directory-phone\">").concat(phoneNumber, "</a>");
        } else {
          phoneHtml = "<span>".concat(phoneNumber, "</span>");
        }
      }

      return phoneHtml;
    }
  }, {
    key: "CanShowFamily",
    value: function CanShowFamily(data) {
      if (!!data && data.householdId > 0 && this.hideFamilyLink === false) {
        return true;
      }

      return false;
    }
  }, {
    key: "CanShowEmail",
    value: function CanShowEmail(data) {
      if (!!data && data.emailUnlisted === false && !!data.emailAddress && this.hideEmail === false && !!this._currentUser.user.email) {
        return true;
      }

      return false;
    }
  }, {
    key: "CanShowAddress",
    value: function CanShowAddress(data) {
      if (!!data && data.homeAddressUnlisted === false && data.addressId > 0 && this.hideAddress === false) {
        return true;
      }

      return false;
    }
  }, {
    key: "CanShowMobilePhone",
    value: function CanShowMobilePhone(data) {
      if (!!data && data.mobilePhoneUnlisted === false && !!data.mobilePhone) {
        return true;
      }

      return false;
    }
  }, {
    key: "CanShowHomePhone",
    value: function CanShowHomePhone(data) {
      if (!!data && data.homePhoneUnlisted === false && !!data.homePhone) {
        return true;
      }

      return false;
    }
  }, {
    key: "DisplayNoResultsFoundMessage",
    value: function DisplayNoResultsFoundMessage() {
      this._$emptyContainer.innerHTML = "";
      this._$emptyContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(this._i18n.noResultsFoundMessage, "</span>\n\t\t\t\t\t\t</div>");
    }
  }, {
    key: "DisplayViewMoreMessage",
    value: function DisplayViewMoreMessage() {
      this._$viewMoreContainer.innerHTML = "";
      this._$viewMoreContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__info\">\n\t\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(this._i18n.viewMoreLabel, "</span>\n\t\t\t\t\t\t\t</div>");
    }
  }, {
    key: "DisplayEnterSearchMessage",
    value: function DisplayEnterSearchMessage() {
      this._$enterSearchMessageContainer.innerHTML = "";
      this._$enterSearchMessageContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__info\">\n\t\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(this._i18n.initialDisplayDirectoryMessage, "</span>\n\t\t\t\t\t\t\t</div>");
    }
  }, {
    key: "DisplayNotAuthorizedToViewMessage",
    value: function DisplayNotAuthorizedToViewMessage() {
      this._$emptyContainer.innerHTML = "";
      this._$emptyContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(this._i18n.notAuthorizedMessage, "</span>\n\t\t\t\t\t\t</div>");
    }
  }, {
    key: "HideEmailSentMessages",
    value: function HideEmailSentMessages() {
      var emailMessageContainer = this._root.querySelectorAll(".emailMessageContainer");

      emailMessageContainer.forEach(function (a) {
        a.innerHTML = "";
      });
    }
  }, {
    key: "HideBigImages",
    value: function HideBigImages() {
      var bigImageContainer = this._root.querySelectorAll(".bigImageContainer");

      bigImageContainer.forEach(function (a) {
        a.innerHTML = "";
      });
    }
  }, {
    key: "DisplayEmailSentMessage",
    value: function DisplayEmailSentMessage(messageContainerId) {
      var emailSentContainer = this._root.querySelector(messageContainerId);

      emailSentContainer.innerHTML = "";
      emailSentContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__success\">\n\t\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(this._i18n.emailSentSuccessfullyMessage, "</span>\n\t\t\t\t\t\t\t</div>");
    }
  }, {
    key: "HideAllMessages",
    value: function HideAllMessages() {
      this._$enterSearchMessageContainer.innerHTML = "";
      this._$viewMoreContainer.innerHTML = "";
      this._$emptyContainer.innerHTML = "";
      this.HideLoadingIndicator();
    }
  }, {
    key: "ShowLoadingIndicator",
    value: function ShowLoadingIndicator() {
      this._$loadingContainer.style.display = "";
      this._$onlineDirectoryCardList.innerHTML = "";
    }
  }, {
    key: "HideLoadingIndicator",
    value: function HideLoadingIndicator() {
      this._$loadingContainer.style.display = "none";
    }
  }, {
    key: "ShowFormWrapper",
    value: function ShowFormWrapper() {
      this._$directoryFormWrapper.style.display = "";
    }
  }, {
    key: "HideFormWrapper",
    value: function HideFormWrapper() {
      this._$directoryFormWrapper.style.display = "none";
    }
  }, {
    key: "HideDirectoryCardHtml",
    value: function HideDirectoryCardHtml() {
      this._$onlineDirectoryCardList.innerHTML = "";
    }
  }, {
    key: "OpenMobileTelephoneDialer",
    value: function OpenMobileTelephoneDialer(phoneNumber) {
      if (!!phoneNumber) {
        document.location.href = "tel:".concat(phoneNumber);
      }
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Online Directory",
        tag: "mpp-online-directory",
        configurationItems: [{
          name: "Hide Address",
          attribute: "hideaddress",
          description: "If true, the map icon will be hidden on all directory cards.",
          required: false,
          type: "bool"
        }, {
          name: "Hide Email",
          attribute: "hideemail",
          description: "If true, the email icon will be hidden on all directory cards.",
          required: false,
          type: "bool"
        }, {
          name: "Hide Family Link",
          attribute: "hidefamilylink",
          description: "If true, the family icon will be hidden on all directory cards.",
          required: false,
          type: "bool"
        }, {
          name: "Hide Birthday Icon",
          attribute: "hidebirthdayicon",
          description: "If true, the birthday icon will be hidden on all directory cards.",
          required: false,
          type: "bool"
        }, {
          name: "Congregation",
          attribute: "congregationid",
          description: "Filters the results by a single Congregation ID.",
          required: false,
          type: "foreignkey",
          fkTable: "Congregations",
          fkFilter: "",
          fkSingleName: "Congregation"
        }, {
          name: "Key Word",
          attribute: "keyword",
          description: "Filters results using key words. A Key Word search looks for a match in the First Name, Last Name, Mobile Phone, Home Phone, or Email address, so choose key word attributes strategically.",
          required: false,
          type: "text"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["householdid", "congregationid", "keyword", "hideaddress", "hideemail", "hidebirthdayicon", "hidefamilylink"];
    }
  }]);

  return MppOnlineDirectory;
}(ComponentBase);
MppOnlineDirectory.registerComponent(MppOnlineDirectory.WidgetDetails.tag, MppOnlineDirectory);